import React from 'react'

function ProductivityUIGridFTE(props) {
    const formatDateString = (dateparam) => {
        return dateparam.toLocaleDateString("en-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    return (
        <div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="qcHeaderbg sl_no">
                            <label>Sl. No</label>
                        </th>
                        <th className="qcHeaderbg message_block">
                            <label>Message</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Active OHR ID</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Employee Name</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Realization Date</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Account</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Region</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Realised to PID</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Realised FTE Impact</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Release Type</label>
                        </th>
                        <th className="qcHeaderbg">
                            <label>Productivity Type</label>
                        </th>
                        <th className="qcHeaderbg message_block">
                            <label>Headcount Release Levers</label>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.data && props.data.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <label>{index + 1}</label>
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                        <label>{item.Msg ? item.Msg : (item.Msg === null || item.Msg === undefined || !item.Msg ? "Successful" : "")}</label>
                                    </td>
                                    <td>
                                        <label>{item.OHR ? item.OHR : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.OHRName ? item.OHRName : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.ReleaseDate ? formatDateString(new Date(item.ReleaseDate)) : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.Account ? item.Account : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.Region ? item.Region : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.PID ? item.PID : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.OHRFTE ? item.OHRFTE : item.FTE ? item.FTE : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.ReleaseType ? item.ReleaseType : "-"}</label>
                                    </td>
                                    <td>
                                        <label>{item.Pvity ? item.Pvity : "-"}</label>
                                    </td>
                                    <td className='release_description'>
                                        <label>{item.HCLever ? item.HCLever : "-"}</label>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ProductivityUIGridFTE